// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import PrintExamPage from "./pages/PrintExamPage";
import CreateExam from "./pages/CreateExam"; // صفحة إضافة الامتحان

export default function App() {
  return (
    <BrowserRouter>
      <div className="main-shell" style={{direction:'rtl'}}>
       <header className="topbar no-print" style={{
  display:'flex',justifyContent:'space-between',alignItems:'center',
  padding:'10px 16px', background:'#fff', borderBottom:'1px solid #e5e7eb'
}}>

          <strong>نظام الاختبارات</strong>
          <nav style={{display:'flex', gap:12}}>
            <NavLink to="/create" className={({isActive})=> isActive ? 'nav-active' : 'nav'}>
              إضافة اختبار
            </NavLink>
            <NavLink to="/" className={({isActive})=> isActive ? 'nav-active' : 'nav'}>
              طباعة أوراق الاختبار
            </NavLink>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<PrintExamPage />} />
          <Route path="/create" element={<CreateExam />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
